module.exports = __webpack_public_path__ + "img/ad-img.23170d61.png";